import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'hoursTimeFormat' })
export class HoursTimeFormatPipe implements PipeTransform {

    private formatZeros(num: number): string {
        return (num < 10 ? '0' : '') + num;
    }

    public transform(seconds: number): string {
        const minutes = Math.ceil(seconds / 60);

        let rest = minutes;

        const hours = Math.floor((rest) / 60);
        rest = rest - hours * 60;

        const mins = Math.floor((rest) / 1);

        const res = this.formatZeros(hours) + ':' + this.formatZeros(mins);

        return res;
    }
}
